import React, { useState, useEffect } from 'react';
import { API_BASE } from '../utils/api';

const RecentReservations = () => {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Use API_BASE from src/utils/api.js

  const fetchReservations = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/reservations`);
      if (!response.ok) throw new Error('Failed to fetch reservations');
      const data = await response.json();
      setReservations(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReservations();
  }, []);

  return (
    <div className="card home-card">
      <div className="card-body p-3">
        <h6 className="card-title mb-3 border-bottom pb-1">Recent Reservations</h6>
        {loading ? (
          <div className="text-center py-5">
             <div className="spinner-border text-primary" role="status" />
          </div>
        ) : error ? (
          <div className="alert alert-danger">{error}</div>
        ) : reservations.length === 0 ? (
          <div className="text-muted text-center py-5">
            <p className="mb-0">You have no active reservations.</p>
            <small>Start by finding a box to reserve.</small>
          </div>
        ) : (
          <div className="table-responsive" style={{ maxHeight: '180px', overflowY: 'auto' }}>
            <table className="table table-striped table-hover small align-middle mb-0">
              <thead className="table-light sticky-top" style={{ top: 0 }}>
                <tr>
                  <th>ID</th>
                  <th>Box</th>
                  <th>Start</th>
                  <th>End</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {reservations.map((res) => (
                  <tr key={res.DHTRSVid}>
                    <td><strong>#{res.DHTRSVid}</strong></td>
                    <td>Box {res.DHTBOX_id || res.DHTRSV_box_Id}</td>
                    <td>{new Date(res.DHTRSV_start_Date).toLocaleString()}</td>
                    <td>{new Date(res.DHTRSV_end_Date).toLocaleString()}</td>
                    <td>
                      <span className={`badge bg-success`}>
                        CONFIRMED
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentReservations;
